export * from './confirmation-page.component';